import { useNavigate } from 'react-router-dom'

// Components
import { Box, Typography, Button, Chip, styled, CircularProgress } from '@mui/material'

// Others
import { ArrowBackIos as ArrowBackIcon } from '@mui/icons-material'
import { FetchBillDetailsQuery } from '../../../../generated'
import { formatStatus, statusColors } from '../../../utils/billing'
import { flexCenter, flexJustifySpaceBetween } from '../../../theme/styleConstants'

interface EditBillHeaderProps {
  bill?: FetchBillDetailsQuery['fetchBillDetails']['bill']
  netTotal: number
  updatingBill: boolean
}

const StickyHeader = styled(Box)(({ theme }) => ({
  ...flexCenter,
  ...flexJustifySpaceBetween,
  position: 'sticky',
  top: '64px',
  zIndex: 99,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  backgroundColor: '#F5F7F8'
}))

const EditBillHeader: React.FC<EditBillHeaderProps> = ({ bill, netTotal, updatingBill }) => {
  const navigate = useNavigate()

  const handleBack = () => {
    if (!bill) return

    navigate(`/billing/bill-detail/${bill.id}`)
  }

  return (
    <>
      <StickyHeader>
        <Button
          startIcon={<ArrowBackIcon sx={{ width: '13px' }} />}
          sx={{
            color: '#5B5675',
            fontWeight: 600,
            fontSize: '14px',
            ml: -1
          }}
          onClick={handleBack}
        >
          BACK
        </Button>

        <Button
          variant="contained"
          disabled={updatingBill}
          type="submit"
          endIcon={updatingBill && <CircularProgress size={16} color="inherit" />}
        >
          Save Bill
        </Button>
      </StickyHeader>

      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="h6" fontWeight={500} color="#333">
          Edit Bill
        </Typography>

        {bill?.status && (
          <Chip
            label={formatStatus(bill.status)}
            sx={{
              color: statusColors[bill.status],
              border: `1px solid ${statusColors[bill.status]}50`,
              backgroundColor: 'transparent'
            }}
          />
        )}
      </Box>
    </>
  )
}

export default EditBillHeader
